import { useEffect, useState } from 'react';
import { Button, Form } from 'antd';
import 'moment-timezone'
import { AuthenticatedUser } from '../../Types/AuthenticatedUser';
import { TextService } from '../../Services/TextService';
import { AuthProvider } from '../../Providers/authProvider';
import { BookyInput } from '../../Components/Forms/BookyInput';
import { IntegrationService } from '../../Services/IntegrationService';
import { IntegrationType } from '../../Types/IntegrationType';

const PingPaymentCreateMerchantForm = () => {

    const [form] = Form.useForm();
    const [user, setUser] = useState({} as AuthenticatedUser | null);

    const GetText = TextService.GetText;

    const FormCreateClick = async (values: any) => {

    };

    const navigateToIntegrations = () => {
        window.location.href = "integrations?state=Connect_2";
    };

    useEffect(() => {
        AuthProvider().GetLoggedInUser().then(user => {
            setUser(user);
        })

    }, []);

    return (
        <Form
            colon={false}
            form={form}
            labelCol={{
                span: 3,
            }}
            onFinish={FormCreateClick}
            wrapperCol={{
                span: 6,
            }}
            layout="vertical"
        >
            <BookyInput label={GetText("PingPaymentCreateMerchantForm_OrganizationName")} req name="organizationname"></BookyInput>
            <BookyInput label={GetText("PingPaymentCreateMerchantForm_OrganizationNumber")} req validateEmailIfFilledIn={true} name="organizationnumber" ></BookyInput>


            <Form.Item label={" "}>
                <Button data-testid="submit-button" style={{ float: 'left' }} size="middle" type="primary" htmlType="submit">
                    {GetText("PingPaymentCreateMerchantForm_CreateMerchant")}
                </Button>
            </Form.Item>
        </Form>)

};

export default PingPaymentCreateMerchantForm;